import classNames from 'classnames';
import Link from 'next/link';
import { AnchorHTMLAttributes } from 'react';

type AnchorLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

const AnchorLink = ({ className, children, ...props }: AnchorLinkProps) => {
  if (!props.href) {
    return children;
  }

  return (
    <Link
      className={classNames('underline hover:no-underline', className)}
      href={props.href}
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </Link>
  );
};

export default AnchorLink;
